import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import App from '@/App.vue'
import router from '@/router/index'
import axios from 'axios'
import VueRouter from 'vue-router'
import dayjs from 'dayjs' // load on demand 
import customParseFormat from 'dayjs/plugin/customParseFormat'
import VueDayjs from 'vue-dayjs-plugin'

// Add dayjs plugins
dayjs.extend(customParseFormat)
import store from '@/store/store'
import Plugin from '@/plugins/plugin.js'
import constants from '@/constants/index'
import { BusinessException, TechnicalException } from '@/services/ErrorHandler'
import i18n from './i18n'

Vue.use(VueRouter)
Vue.use(VueDayjs, { dayjs })
Vue.use(Vuetify)
Vue.use(Plugin)

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false
axios.defaults.baseURL = `${process.env.VUE_APP_ROOT_API}`
axios.defaults.maxContentLength = process.env.VUE_APP_MAX_CONTENT_LENGTH
axios.defaults.maxBodyLength = process.env.VUE_APP_MAX_CONTENT_LENGTH

Vue.config.errorHandler = function (err, vm, info) {
  if (err instanceof BusinessException) {
    var message = constants.ERROR_CODES.hasOwnProperty(err.code) ? i18n.t(constants.ERROR_CODES[err.code]) : err.message
    store.dispatch('global/setSnackbar', { show: true,
      color: 'error',
      text: message,
      timeout: 6000
    })
  }
  if (err instanceof TechnicalException) {
    store.dispatch('global/setSnackbar', { show: true,
      color: 'error',
      text: 'The service is not available at this moment. Please try later.',
      timeout: 6000
    })
  }
  console.log(err, info)
}

new Vue({ // eslint-disable-line no-new
  i18n,
  el: '#app',
  store,
  router,
  async created () {
    this.$store.dispatch('siteconfig/load')
    await this.$store.dispatch('countries/loadWithFlag')

    let isAuthenticated = this.$store.getters['userdetails/isAuthenticated']
    if (isAuthenticated) {
      await this.$store.dispatch('userdetails/loadUserPackages')
      this.$store.dispatch('userdetails/loadUserInfos')
      await this.$store.dispatch('countries/load')
    }
  },
  mounted () {
    // Update the CSS Variables when mounted
    let config = this.$store.getters['siteconfig/config']
    this.$el.style.setProperty('--primary-color', config.primaryColor)
    document.title = config.siteName
    this.$vuetify.theme = {
      primary: config.primaryColor
    }
  },
  render: h => h(App)
})
